const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

let timeCounter;

export function toggleLoginModal() {
    const $modal = document.querySelector('.modal.login');
    const $ctaLogin = document.querySelector('.display-login');

    if (!$modal || !$ctaLogin) return;

    const active = 'active';
    const overlay = document.createElement('div');
    overlay.classList.add('login-overlay');

    $ctaLogin.addEventListener('click', (event) => {
        event.preventDefault();

        $modal.classList.add(active);
        document.body.appendChild(overlay);

        if (document.querySelector('.mobile-nav').classList.contains('open')
            && document.querySelector('.nav').classList.contains('open')
        ) {
            document.querySelector('.mobile-nav').classList.remove('open');
            document.querySelector('.nav').classList.remove('open');
        }
    });

    $modal.querySelector('.close').addEventListener('click', (event) => {
        event.preventDefault();

        $modal.classList.remove(active);
        document.querySelector('.login-overlay').remove();
    });

    document.addEventListener('click', (event) => {
        if (event.target.classList.contains('login-overlay')) {
            $modal.classList.remove(active);
            document.querySelector('.login-overlay').remove();
        }
    });
}

export function auth() {
    const $form = document.querySelector('.login .form');

    if (!$form) return;

    const $loginEmail = document.querySelector('.login .email');
    const $loginPassCode = document.querySelector('.login .pass');
    const $submit = document.querySelector('.login .submit');

    $submit.addEventListener('click', (event) => {
        event.preventDefault();
        let $email = !!validateEmail($loginEmail.value) ? validateEmail($loginEmail.value).input : null;

        if (!$email) {
            $loginEmail.parentElement.querySelector('.error').classList.remove('hidden');
        }

        if (!!$email && !!$loginPassCode.parentElement.classList.contains('hidden')) {
            $email = btoa($email);

            if (!!sessionStorage.getItem('t_' + $email)) {
                if (!$loginEmail.parentElement.querySelector('.error').classList.contains('hidden')) {
                    $loginEmail.parentElement.querySelector('.error').classList.add('hidden');
                }

                $loginEmail.setAttribute('disabled', true);

                $form.querySelectorAll('.init-block').forEach(el => {
                    el.classList.add('hidden');
                });

                $form.querySelectorAll('.verify-block').forEach(el => {
                    el.classList.remove('hidden');
                });

                countdown($email);
            }

            if (!sessionStorage.getItem('t_' + $email)) {
                let $path = $form.getAttribute('data-action') + `?email=${$email}`;
                fetch($path)
                    .then(response => {
                        if (response.status === 200) {
                            if (!$loginEmail.parentElement.querySelector('.error').classList.contains('hidden')) {
                                $loginEmail.parentElement.querySelector('.error').classList.add('hidden');
                            }

                            $loginEmail.setAttribute('disabled', true);

                            $form.querySelectorAll('.init-block').forEach(el => {
                                el.classList.add('hidden');
                            });

                            $form.querySelectorAll('.verify-block').forEach(el => {
                                el.classList.remove('hidden');
                            });

                            countdown($email);
                        }
                        else {
                            $loginEmail.parentElement.querySelector('.error').classList.remove('hidden');
                        }
                    });
            }
        }

        if (!!$email && !!$loginPassCode.value) {
            $email = btoa($email);
            let $pass = btoa($loginPassCode.value);
            let $id5 = window.__id5UserId ?? null;
            let $path = $form.getAttribute('data-action') + `?email=${$email}&password=${$pass}&id5=${$id5}`;
            fetch($path)
                .then(response => {
                    if ([200, 201].includes(response.status)) {
                        sessionStorage.removeItem('t_' + $email);
                        location.href = '/';
                    }
                    else {
                        $loginPassCode.parentElement.querySelector('.error').classList.remove('hidden');
                    }
                });
        }
    });

    $form.querySelector('.update').addEventListener('click', (event) => {
        $loginEmail.value = '';
        $loginPassCode.value = '';
        $loginEmail.removeAttribute('disabled');

        if (!$loginPassCode.parentElement.querySelector('.error').classList.contains('hidden')) {
            $loginPassCode.parentElement.querySelector('.error').classList.add('hidden');
        }

        $form.querySelectorAll('.init-block').forEach(el => {
            el.classList.remove('hidden');
        });

        $form.querySelectorAll('.verify-block').forEach(el => {
            el.classList.add('hidden');
        });
    });

    $form.querySelector('.resend').addEventListener('click', (event) => {
        if ($form.querySelector('.resend').classList.contains('disabled')) {
            return;
        }

        let $email = !!validateEmail($loginEmail.value) ? validateEmail($loginEmail.value).input : null;

        if (!$email) {
            $loginEmail.parentElement.querySelector('.error').classList.remove('hidden');
        }

        if (!!$email) {
            $email = btoa($email);
            let $path = $form.getAttribute('data-action') + `?email=${$email}`;

            if (!$loginPassCode.parentElement.querySelector('.error').classList.contains('hidden')) {
                $loginPassCode.parentElement.querySelector('.error').classList.add('hidden');
            }

            fetch($path)
                .then(response => {
                    if (response.status === 200) {
                        $loginPassCode.value = '';
                        countdown($email);
                    }
                });
        }
    });
}

function countdown(id) {
    const timer = 1;
    let key = 't_' + id;
    let countdownTime = null;
    let _now = new Date();

    if (!!sessionStorage.getItem(key)) {
        countdownTime = parseInt(sessionStorage.getItem(key));

        if (countdownTime - (new Date().getTime()) <= 0) {
            sessionStorage.removeItem(key);
            clearInterval(timeCounter);
            timeCounter = null;
            document.getElementById('timer').innerHTML = '';
        }
    } else {
        countdownTime = _now.setMinutes(_now.getMinutes() + timer);
        sessionStorage.setItem(key, countdownTime.toString());
    }

    document.getElementById('timer').classList.remove('hidden');
    document.querySelector('.login .form .resend').classList.add('disabled');

    if (!!timeCounter) {
        clearInterval(timeCounter);
        timeCounter = null;
        document.getElementById('timer').innerHTML = '';
    }

    timeCounter = setInterval(() => {
        let _moment = new Date().getTime();
        let distance = countdownTime - _moment;
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        document.getElementById('timer').innerHTML = minutes + ':' + (seconds < 10 ? '0' + seconds : seconds);

        if (distance <= 0) {
            clearInterval(timeCounter);
            sessionStorage.removeItem(key);
            document.getElementById('timer').innerHTML = '';
            document.getElementById('timer').classList.add('hidden');
            document.querySelector('.login .form .resend').classList.remove('disabled');
        }
    }, 1000);
}
